import React, { useState } from "react";
import SelectorCantidadSancion from "./SelectorCantidadSancion";
import InfoCadete from "../tools/InfoCadete";
const Sancion = ({ sancionPasada }) => {
  
  if (!sancionPasada) return <p>No hay datos disponibles</p>;

  const getValue = (value) => (value !== null && value !== undefined ? value : "-");

  return (
    <div className="border p-4 rounded shadow bg-white">
      <h5 className="text-xl font-bold mb-3" style={{fontStyle:"bold"}}><strong>Pliego de Sanción nro: {getValue(sancionPasada.id)}</strong></h5>
      <p><strong>Estado de esta Sancion:</strong> {getValue(sancionPasada.estado)}</p>
      <hr/>
      <div>
      <p style={{cursor:"pointer"}} onClick={()=>InfoCadete(sancionPasada.cadeteDni)}><strong >Cadete:</strong> {sancionPasada.cadete.cadeteApellido + " "+ sancionPasada.cadete.cadeteNombre +"("}{getValue(sancionPasada.cadeteDni)+")"}</p>
      <p><strong>Sede del Cadete:</strong> {getValue(sancionPasada.cadeteSede)}</p>
      <p><strong>Promoción:</strong> {getValue(sancionPasada.cadete.Promocions[0].nombre)}</p>
      </div>   <hr/>
      <div>
      <p><strong>Fecha Falta Cometida:</strong> {getValue(sancionPasada.fechaFaltaCometida)}</p>
      <p><strong>Usuario que Sanciona:</strong> {getValue(sancionPasada.usuarioSanciona)}</p>
     

      <p><strong>Artículo:</strong> {getValue(sancionPasada.articulo)}</p>
      <p><strong>Inciso:</strong> {getValue(sancionPasada.inciso)}</p>
      <p><strong>Descripción de la falta:</strong> {getValue(sancionPasada.descripcionFalta)}</p>
      <p><strong>Tipo de Sancion :</strong> {getValue(sancionPasada.tipo)}</p>
      {sancionPasada.tipo=="Amonestacion"?  <p><strong>Cantidad impuesta:</strong> {getValue(sancionPasada.cantidad)}</p>:  <p><strong>Cantidad impuesta:</strong> -</p>}
      <p><strong>Fecha Notificado de la falta:</strong> {sancionPasada.fechaNotificado?getValue(new Date(sancionPasada.fechaNotificado).toLocaleString()):""}</p>
      <p><strong>¿Realizó descargo el cadete?:</strong> {sancionPasada.descargo?
      
      <>Si.<hr/> <strong></strong>
      <p> <strong>Descargo:</strong>
    {getValue(sancionPasada.descargo) }</p>
     <p><strong>Fecha de Descargo:</strong> {sancionPasada.fechaHoraDescargo?getValue(new Date(sancionPasada.fechaHoraDescargo).toLocaleString()):"-"}</p> </>:
      
    
      "No"}</p>
      </div>   <hr/>
<div>
      <p><strong>Usuario que controla y resuelve:</strong> {sancionPasada.usuarioControla?getValue(sancionPasada.usuarioControla):"-"}</p>
      <p><strong>Resuelve usuario que controla:</strong> {sancionPasada.resuelveUsuarioControla?getValue(sancionPasada.resuelveUsuarioControla):"-"}</p>
      <p><strong>Cantidad confirmada:</strong> {sancionPasada.cantidadConfirma?getValue(sancionPasada.cantidadConfirma):"-"}</p>   </div>   <hr/>
      <div>
      <p><strong>Notifica Resolucion:</strong> {sancionPasada.usuarioNotificaConfirma?getValue(sancionPasada.usuarioNotificaConfirma):"-"}</p>
      <p><strong>Fecha de Notificado:</strong> {sancionPasada.fechaNotificadoConfirma?getValue(new Date(sancionPasada.fechaNotificadoConfirma).toLocaleString()):"-"}</p>

      </div>   <hr/>
      <div>
      {(
    sancionPasada.fechaRecursa &&
    sancionPasada.fechaRecursa !== "0000-00-00 00:00:00"
) ? (
    <>
        <p style={{ color: "red" }}>
            <strong>Presentó Reclamo por Sanción</strong>
        </p>
        <p>
            <strong>Fecha Reclamo:</strong>{" "}
            {new Date(sancionPasada.fechaRecursa).toLocaleString()}
        </p>
        <p>
            <strong>Argumento: </strong>{" "}
            {sancionPasada.recursa}.-
        </p>
        
        {sancionPasada.usuarioResuelveRecurso &&
         sancionPasada.usuarioResuelveRecurso !== "" && (
            <p>
                <strong>Resolvió Reclamo Sanción:</strong>{" "}
                {sancionPasada.usuarioResuelveRecurso } 
            </p>
        )}
         {sancionPasada.resuelveRecurso &&
         sancionPasada.resuelveRecurso !== "" && (
            <p>
                <strong>Resolviendo: </strong>{" "}
                {sancionPasada.resuelveRecurso } 
            </p>
        )}
         {sancionPasada.cantidadResuelveRecurso &&
         sancionPasada.cantidadResuelveRecurso !== "" && (
            <p>
                <strong>Cantidad Final: </strong>{" "}
                {sancionPasada.cantidadResuelveRecurso } 
            </p>
        )}
         {sancionPasada.fechaNotificadoResuelve &&
         sancionPasada.fechaNotificadoResuelve !== "" && (
            <p>
                <strong>Fecha Notificado Resolucion Reclamo: </strong>{" "}
                { new Date(sancionPasada.fechaNotificadoResuelve ).toLocaleString()} 
            </p>
        )}
        <hr />
    </>
) : null}


      </div>
      <div>
      {sancionPasada.fechaSalvedadRectificada?<p><strong>Fecha Salvedad Rectificada:</strong> {getValue(sancionPasada.fechaSalvedadRectificada)}</p>:""}
      </div>
     
     
    </div>
  );
};

export default Sancion;
